import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import styles from './index.module.scss';
import days from '../../utils/days';

const formatTime = (hour, minute) => moment().set('hour', hour).set('minute', minute).format('h:mma');

const Schedule = ({ schedule }) => {
  if (!schedule) {
    return <></>;
  }
  return (
    <div className={styles.schedule}>
      {schedule.map((item) => (
        <p key={item.weekday} className={styles.row}>
          <span className={styles.day}>{days[item.weekday].shorthand}:</span>
          {item.time_ranges.map((range) => (
            <React.Fragment key={`${range.display}-${item.weekday}`}>
              <span>{` ${formatTime(range.start_hour, range.start_min)} - ${formatTime(range.end_hour, range.end_min)}`}</span>
              <br />
              <span className={styles.day} />
            </React.Fragment>
          ))}
        </p>
      ))}
    </div>
  );
};

Schedule.propTypes = {
  schedule: PropTypes.array,
};

export default Schedule;
